<template>
    <div id="platformSupervise" class="background-ash pl20 pr20 pb20" v-loading="loading"> <!-- 系统管理-平台监管 -->
        <!--搜索条件-->
        <div class="search_list background-white">
            <ul class="lists">
                <li>
                    <span>平台名称</span>
                    <el-select size="small" class="select" collapse-tags v-model="search.platformCode" >
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in platformList" :key="item.platformCode" :label="item.platformName" :value="item.platformCode"></el-option>
                    </el-select>
                </li>
				<li>
                    <span>是否处理</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="search.status" >
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未处理" value="INIT"></el-option>
                        <el-option label="已处理" value="PROCESSED"></el-option>
                    </el-select>
                </li>
            </ul>
			<div class="btns" style="width: 140px;">
                <el-button size="small" type="primary" @click="pageNo = 1, getList()">搜索</el-button>
                <el-button size="small" type="primary" plain @click="reset()">重置</el-button>
            </div>
        </div>
        <!--内容-->
        <div class="pt20 content">
            <div class="tab">
                <el-table ref="checkList" size="mini" :data="list" tooltip-effect="dark" height="100%">
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column label="平台名称" prop="platformName"></el-table-column>
                    <el-table-column label="创建时间" prop="gmtCreate"></el-table-column>
                    <el-table-column label="类型">
                        <span slot-scope="scope">{{ scope.row.type === 1 ? '商品比价' : '' }}</span>
                    </el-table-column>
                    <el-table-column label="问题说明" prop="remark"></el-table-column>
                    <el-table-column label="是否处理">
                        <span slot-scope="scope">
                            {{ scope.row.status === 'INIT' ? '未处理' : '' }}
                            {{ scope.row.status === 'PROCESSED' ? '已处理' : '' }}
                        </span>
                    </el-table-column>
                    <el-table-column label="操作" fxied="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" v-if="scope.row.status === 'INIT'" @click="handle(scope.row)">标记处理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="changePageNo" :current-page.sync="pageNo"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
export default {
	name: 'platformSupervise', //数据分析-查询记录
	data () {
		return {
            loading: false,
            search_back: {
                platformCode: '',
                status: ''
            },
			search: {},
            pageNo: 1,
            pageSize: 10,
            total: 0,
            platformList: [],
            list: [],
		}
	},
	methods: {
        // 改变每页个数
        changePageSize (val) {
            this.pageSize = val
            this.pageNo = 1
            this.getList()
        },
        // 改变页码
        changePageNo (val) {
            this.pageNo = 1
            this.getList()
        },
        // 获取全部平台
        getAllPlatform () {
            this.loading = true
            this.$http('POST', '/admin/platform/all', {}, {}, (status, res) => {
                this.loading = false
                if (status) {
                    if (res.data && res.data.length > 0) {
                        this.platformList = res.data
                    } else {
                        this.platformList = []
                    }
                    this.reset()
                }
            })
        },
        // 获取数据列表
        getList () {
            let options = {
                platformCode: this.search.platformCode, // 平台
                status: this.search.status,
                pageNo: this.pageNo - 1,
                pageSize: this.pageSize
            }
            for (let key in options) {
                if (options[key] === '') {
                    delete options[key]
                }
            }
            this.loading = true
            this.$http('POST', '/admin/supervision/page', {}, options, (status, res) => {
                this.loading = false
                if (status) {
                    if (res.totalCount > 0) {
                        this.list = res.content
                    } else {
                        this.list = []
                    }
                    this.total = res.totalCount
                }
            })
        },
        // 重置搜索条件
        reset () {
            this.search = JSON.parse(JSON.stringify(this.search_back))
            this.pageNo = 1
            this.pageSize = 10
            this.getList()
        },
        // 标记处理
        handle (e) {
            this.$confirm('是否标记为已处理？', '标记处理', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let options = {
                        id: e.id
                    }
                    this.loading = true
                    this.$http('POST', '/admin/supervision/process', {}, options, (status, res) => {
                        this.loading = false
                        if (status) {
                            this.success('处理成功')
                            this.getList()
                        }
                    })
                }).catch()
        }
	},
	mounted () {
        this.getAllPlatform() // 获取所有平台
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#platformSupervise {width: 100%;height: calc(100vh - 132px);}
#platformSupervise .content {height: calc(100% - 76px);}
#platformSupervise .content .tab {height: calc(100% - 72px);}
</style>



// WEBPACK FOOTER //
// src/views/system/platformSupervise.vue